<script setup lang="ts">
const props = defineProps({
  to: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
  external: {
    type: Boolean,
    default: false,
  },
  download: {
    type: [Boolean, String],
    default: false,
  },
  ariaLabel: {
    type: String,
    default: undefined,
  },
  icon: {
    type: String,
    default: undefined,
  },
});

const downloadFilename = computed(() => {
  if (!props.download) {
    return undefined;
  }

  if (typeof props.download === "string") {
    return props.download;
  }

  return props.to.split("/").pop() || "";
});

const openInNewTab = computed(() => props.external && !props.download);
</script>

<template>
  <a
    v-if="props.download"
    class="pdg-button-primary"
    :href="props.to"
    :download="downloadFilename"
    :aria-label="props.ariaLabel"
  >
    <span class="pdg-button-primary__label">{{ props.label }}</span>
    <i v-if="props.icon" :class="props.icon" aria-hidden="true"></i>
  </a>
  <NuxtLink
    v-else
    class="pdg-button-primary"
    :to="props.to"
    :target="openInNewTab ? '_blank' : undefined"
    :external="props.external"
    :rel="openInNewTab ? 'noopener' : undefined"
    :aria-label="props.ariaLabel"
  >
    <span class="pdg-button-primary__label">{{ props.label }}</span>
    <i v-if="props.icon" class="pdg-button-primary__icon" :class="props.icon" aria-hidden="true"></i>
  </NuxtLink>
</template>

<style scoped lang="scss">
@import "../scss/includes.scss";
@import "../scss/button-primary";
</style>
